import api from "./api";

export default class SysTypesApi {
  static sysTypeContacts = async (page: number, recordsPage: number, search: string) => {
    const response = await api.get(`/sysTipoContato?Page=${page}&RecordsPerPage=${recordsPage}&Search=${search}`);
    return response.data;
  };

  static sysTypeAccount = async (page: number, recordsPage: number, search: string) => {
    const response = await api.get(`/sysTipoConta?Page=${page}&RecordsPerPage=${recordsPage}&Search=${search}`);
    return response.data;
  };
};
